import React from "react";
import { useRecoilValue } from "recoil";
import { userAtom } from "../global/globalState";

const Home = ({ history }) => {
    const user = useRecoilValue(userAtom);
    console.log(user);
    const cta = () => {
        if (!user) {
            history.push("/SignUp");
        } else {
            if (user.type === "user") history.push("/dashboard");
            else history.push("/dashboardTeacher");
        }
    };

    return (
        <div className="Home">
            <div className="container">
                {/* TOP SECTION  */}
                <div className="top">
                    <div className="left">
                        <h3 className="welcome">
                            Welcome to{" "}
                            <div className="logo">
                                <h1>Aqua</h1>
                            </div>
                        </h3>
                        <p>
                            A service to connect students and teahcers.
                            <br />
                            Aqua is a tool that has been developed to improve
                            and manage continuos evaluation of students by
                            academic institutions like schools and colleges
                        </p>
                        <button className="primary cta" onClick={() => cta()}>
                            {user ? "Go To Dashboard" : "Get Started"}
                        </button>
                    </div>
                    <div className="right">
                        <img src={require("../assets/svg/doc3.svg")} alt="" />
                    </div>
                </div>

                <div className="middle">
                    <h2>Features</h2>
                    <div className="cards">
                        <div className="card">
                            <img
                                src={require("../assets/icons/quiz.svg")}
                                alt="Heart Icon"
                            />
                            <div className="content">
                                <h4>Quiz Generation</h4>
                                <p>
                                    This feature will allow the Teacher to
                                    generate a list of questions from a single
                                    word(i.e Wikipedia Articles) or from a
                                    specific article which they can upload.This
                                    helps in saving precious time for a
                                    important or frivoulous quiz.
                                </p>
                            </div>
                        </div>
                        <div className="card">
                            <img
                                src={require("../assets/icons/plagiarism.svg")}
                                alt="Heart Icon"
                            />
                            <div className="content">
                                <h4>Plagiarism detection</h4>
                                <p>
                                    This feature will allow the Teacher to check
                                    for plagiarism between students for a
                                    subjective assignment. Furthermore, this
                                    will reduce confusion and the time can be
                                    saved here and teacher can recheck highly
                                    plagiarised assignments.
                                </p>
                            </div>
                        </div>
                        <div className="card">
                            <img
                                src={require("../assets/icons/teaching.svg")}
                                alt="Heart Icon"
                            />
                            <div className="content">
                                <h4>Assignment Portal </h4>
                                <p>
                                    This will allow the students to upload their
                                    assignments and teachers to see them. This
                                    will help them to asses students on how they
                                    have performed and can reviewed in the
                                    future.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Home;
